import { cx } from "shared/utils";

export const VerticalSpacer = ({
  isLast,
  isActive,
  height,
  className,
  roundClassName,
  horizontalLineClassName
}: {
  isLast?: boolean;
  isActive?: boolean;
  height?: number;
  className?: string;
  roundClassName?: string;
  horizontalLineClassName?: string;
}) => {
  return (
    <>
      <div
        className={cx(
          "border-l border-dashed ml-5",
          isLast ? "min-h-[20px] -translate-y-1/2" : "min-h-[40px]",
          isActive ? "border-primary-500" : "border-content-100",
          className
        )}
        style={{
          height
        }}
      />
      <div
        className={cx(
          "border-t border-dashed w-4",
          isActive ? "border-primary-500" : "border-content-100",
          horizontalLineClassName
        )}
      />
      <div
        className={cx(
          "h-[5px] w-[5px] rounded-full mr-2",
          isActive ? "bg-primary-500" : "bg-content-100",
          roundClassName
        )}
      />
    </>
  );
};
